const routes = [
  {
    path: "/individuation/gexinghua",
    title: "首页",
    element: () => import("@/views/GeXingHua/Home"),
  },
  {
    path: "/individuation/tieba",
    title: "",
    element: () => import("@/views/GeXingHua/Home"),
  },
  {
    path: '/individuation/zhongxin',
    title: "辅导中心",
    element: () => import("@/views/GeXingHua/GuideCenter"),
  },
  {
    path: '/individuation/xuexiao',
    title: "复读学校",
    element: () => import("@/views/GeXingHua/XueXiao"),
  },
  {
    path: '/individuation/guihua',
    title: "学业规划",
    element: () => import("@/views/GeXingHua/Guihua"),
  },
  {
    path: '/individuation/shuqi',
    title: "暑期招生",
    element: () => import("@/views/GeXingHua/Shuqi"),
  },
  {
    path: '/individuation/fudu',
    title: "高考复读",
    element: () => import("@/views/GeXingHua/Fudu"),
  },
  {
    path: '/campus/xiaoqu',
    title: "全国校区",
    element: () => import("@/views/GeXingHua/Xiaoqu"),
  },
]

export default routes;